import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bypassLabel: {
    id: 'KimRating.BypassLabel',
    defaultMessage: 'Kundenumfrage überspringen',
  },
  helpUs: {
    id: 'KimRating.HelpUs',
    defaultMessage: 'Hilf uns, besser zu werden!',
  },
  questionStorefront: {
    id: 'KimRating.QuestionStorefront',
    defaultMessage: 'Wie gefällt dir die Startseite?',
  },
  questionDetailpage: {
    id: 'KimRating.QuestionDetailpage',
    defaultMessage: 'Wie gefällt dir die Detailseite?',
  },
  questionSearch: {
    id: 'KimRating.QuestionSearch',
    defaultMessage: 'Wie zufrieden bist du mit unserer Produktliste/Suche?',
  },
  questionWishlist: {
    id: 'KimRating.QuestionWishlist',
    defaultMessage: 'Wie gefällt dir der Merkzettel?',
  },
  questionMyaccountBookings: {
    id: 'KimRating.questionMyaccountBookings',
    defaultMessage: 'Wie gefällt Ihnen die Buchungsseite?',
  },
  questionMyaccountOrders: {
    id: 'KimRating.questionMyaccountOrders',
    defaultMessage: 'Wie gefällt Ihnen die Bestellungen und Lieferungen Seite?',
  },
  questionMyaccountOverview: {
    id: 'KimRating.questionMyaccountOverview',
    defaultMessage: 'Wie gefällt Ihnen die Übersichtsseite?',
  },
  questionMyaccountPersonalData: {
    id: 'KimRating.questionMyaccountPersonalData',
    defaultMessage: 'Wie gefällt Ihnen die Persönliche Daten Seite?',
  },
  ratingVeryUnsatisfied: {
    id: 'KimRating.RatingVeryUnsatisfied',
    defaultMessage: 'Sehr unzufrieden',
  },
  ratingUnsatisfied: {
    id: 'KimRating.RatingUnsatisfied',
    defaultMessage: 'Unzufrieden',
  },
  ratingNor: {
    id: 'KimRating.RatingNor',
    defaultMessage: 'Weder noch',
  },
  ratingSatisfied: {
    id: 'KimRating.RatingSatisfied',
    defaultMessage: 'Zufrieden',
  },
  ratingVerySatisfied: {
    id: 'KimRating.RatingVerySatisfied',
    defaultMessage: 'Sehr zufrieden',
  },
  ratingOnwards: {
    id: 'KimRating.RatingOnwards',
    defaultMessage: 'Weiter',
  },
});
